export default {
      id: "Logo-header-usage",
      viewBox: "0 0 363 73",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#Logo-header-usage",
      toString: function () {
        return this.url;
      }
    }